/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'VERBAL_COMMUNICATION',
              'WRITTEN_COMMUNICATION_I_E_SUPPLY_CONTRACTS_MIGHT_INCLUDE_REFERE',
              'MULTI_MEDIA_COMMUNICATION_I_E_VIDEO_ONLINE_LEARNING_ETC_',
              'TRAINING_NEW_SUBCONTRACTORS_SUPPLIERS_RECEIVE_ONBOARDING_TRAINI',
              'TRAINING_EXISTING_SUBCONTRACTORS_SUPPLIERS_RECEIVE_ON_GOING_TRA',
              'OTHER',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    how_does_the_fac_prov_comm_and_training_to_supplierssubcontract: valueSchema,
  },
}
